import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantVideoModel } from 'src/app/models/tenants/tenant-video.model';
import { Configuration } from 'src/assets/Configuration';

@Injectable({
  providedIn: 'root'
})
export class TenantVideoService {
  private readonly apiUrl = `${Configuration.getApiBaseUrl()}/tenant-video`;

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getPendingTenantVideo(): Observable<TenantVideoModel | null> {
    return this.httpClient.get<TenantVideoModel | null>(this.apiUrl);
  }

  completeTenantVideo(): Observable<void> {
    return this.httpClient.post<void>(`${this.apiUrl}/complete`, {});
  }
}